import { createFileRoute } from "@tanstack/react-router";
import SecureNotePage from "@/pages/SecureNotePage";

export const Route = createFileRoute("/tools/secure-note/")({
  component: SecureNotePage,
});
